import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchLogs } from 'actions/logs';
import { findUser } from 'actions/users';

export const parseUserFromActorString = (actorStr) => {
  if (!actorStr) {
    return null;
  }

  const userId = actorStr.split(':').pop();

  if (parseInt(userId, 10).toString() !== userId) {
    return null;
  }

  return userId;
};

export const comparator = (a, b) => {
  if (a.event_ts < b.event_ts) {
    return 1;
  }
  if (a.event_ts > b.event_ts) {
    return -1;
  }

  return 0;
};

const withPendingArrangementAgent = (DecoratedComponent) => {
  class WithPendingArrangementAgent extends Component {
    state = {
      pendingArrangementAgent: null,
    };

    componentDidMount() {
      if (this.props.purchase) {
        this.fetchData();
      }
    }

    componentDidUpdate(oldProps) {
      const newPurchase = this.props.purchase;
      const oldPurchase = oldProps.purchase;
      if (
        (newPurchase && !oldPurchase) ||
        (newPurchase && oldPurchase && newPurchase.id !== oldPurchase.id)
      ) {
        this.fetchData();
      }
    }

    fetchData() {
      const { purchase, fetchLogs, findUser } = this.props;

      if (!purchase || purchase.status !== 'pending_arrangement') {
        return; // don't need to load data;
      }

      fetchLogs({
        event: 'payment_pending_arrangement_set',
        model: 'purchase',
        model_id: purchase.id,
      })
        .then((logs) => {
          if (logs.length) {
            const sortedLogs = [...logs].sort(comparator);
            return parseUserFromActorString(sortedLogs[0].actor_id);
          }
        })
        .then((userId) => {
          if (userId) {
            findUser(userId).then((user) => {
              this.setState({ pendingArrangementAgent: user });
            });
          }
        });
    }

    render() {
      const { children, ...props } = this.props;
      const { pendingArrangementAgent } = this.state;

      return React.createElement(
        DecoratedComponent,
        {
          ...props,
          pendingArrangementAgent,
        },
        children,
      );
    }
  }

  const mapDispatchToProps = {
    fetchLogs,
    findUser,
  };

  return connect(null, mapDispatchToProps)(WithPendingArrangementAgent);
};

export default withPendingArrangementAgent;
